import React from 'react';
import immutable from 'immutable';
import ConstValues from 'utils/const';
import uniqueId from 'lodash/uniqueId';
import Tooltip from 'components/pure/utils/Tooltip';

require('styles/utils/CircularCardLabelWithTooltip.styl');

const classNames = require('classnames');
const labelSpanStyle = immutable.Map({
  color: ConstValues.cardLabelSpanDefaultColor,
});

class CircularCardLabelWithTooltip extends React.Component {
  /** Return a style object for <span/> within the parent <div/> component */
  spanStyle() {
    return labelSpanStyle.merge(this.props.spanStyle).merge(this.props.hoverStyle).toObject();
  }

  render() {
    const classname = classNames('circular-card-label-with-tooltip', this.props.className);
    const divId = uniqueId('circular-card-label-with-tooltip');
    return (
      <div
        ref={c => (this.parent = c)}
        data-tip
        data-for={divId}
        className={classname}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}>
        <span className="cursor-default" style={this.spanStyle()}>
          {this.props.label}
        </span>
        <Tooltip
          id={divId}
          effect="solid"
          place="top"
          renderToLayer={true}
          active={this.props.showTooltip}
          parent={this.parent}>
          <div>
            <span>{this.props.tooltip}</span>
          </div>
        </Tooltip>
      </div>
    );
  }
}

export default CircularCardLabelWithTooltip;
